/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestMaxUnitTestMetadataLengthSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('AUTO_TEST_MAX_UNIT_TEST_METADATA_LENGTH'),
    ],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class AutoTestMaxUnitTestMetadataLengthSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestMaxUnitTestMetadataLengthSettingParser.decode(input).map(res => new AutoTestMaxUnitTestMetadataLengthSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestMaxUnitTestMetadataLengthSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestMaxUnitTestMetadataLengthSettingParser.encode(data);
    }
    static schema() {
        return AutoTestMaxUnitTestMetadataLengthSettingParser.schema();
    }
}
